<template>
  <div>
    <div
      class="grid lg:grid-cols-12 md:grid-cols-8 grid-cols-1 gap-4 w-full items-center py-4 my-0"
    >
      <div class="md:col-span-3 col-span-12 flex flex-row md:flex-row">
        <span class="text-left font-bold md:hidden mr-2">Nome:</span>
        <p class="md:text-left truncate">{{ data.name }}</p>
      </div>

      <div class="md:col-span-1 col-span-6 flex flex-row">
        <span class="text-left font-bold md:hidden mr-2">CRM:</span>
        <p>{{ data.crm }}</p>
      </div>

      <div class="md:col-span-1 col-span-6 flex flex-row">
        <span class="text-left font-bold md:hidden mr-2">UF:</span>
        <p>{{ data.crmUf }}</p>
      </div>

      <div class="md:col-span-2 col-span-12 flex flex-row">
        <span class="text-left font-bold md:hidden mr-2">Inserido em:</span>
        <p>{{ data.insertedAt }}</p>
      </div>

      <div class="md:col-span-3 col-span-6 flex flex-row">
        <span class="text-left font-bold md:hidden mr-2">Por:</span>
        <UserDisplay :name="data.insertedBy" />
      </div>

      <div
        class="md:col-span-2 col-span-12 flex flex-row justify-start md:justify-start gap-8 mt-4 md:mt-0"
      >
        <v-icon
          @click="openModal(data.id, data.name)"
          class="share-icon hover:cursor-pointer"
          color="negative"
          :icon="mdiPlaylistRemove"
        />
      </div>
    </div>
  </div>

  <ConfirmAlert
    :key="showModalKey"
    :showAlert="showModal"
    :title="modalTitle"
    :message="modalDescription"
    :loading="isLoading"
    @onCancel="showModal = false"
    @onConfirm="handleConfirm"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { mdiPlaylistRemove } from '@mdi/js'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'
import { useErrorToast } from '@/composables/useErrorToast'

import UserDisplay from '../AvatarUser/index.vue'
import ConfirmAlert from '@/components/designSystem/Alerts/ConfirmAlert.vue'

interface BlockedDoctorDisplayData {
  id: number
  name: string
  crm: string
  crmUf: string
  insertedAt: string
  insertedBy: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
  data: BlockedDoctorDisplayData
}>()

const showModal = ref(false)
const showModalKey = ref(0)
const isLoading = ref(false)
const selectedDoctor = ref<{ id: number; name: string }>({ id: 0, name: '' })

const modalTitle = ref('')
const modalDescription = ref('')
const policyStore = useDsPolicyStore()
const { notifyError } = useErrorToast()

const openModal = (id: number, name: string) => {
  selectedDoctor.value = { id, name }
  modalTitle.value = 'Confirmar a remoção'
  modalDescription.value = `Você tem certeza que deseja remover ${name} da lista de bloqueados?`
  showModalKey.value++
  showModal.value = true
}

const handleConfirm = async () => {
  // Validação local ANTES do try: um `throw` aqui dentro cairia no `notifyError` e
  // apareceria como falha de API ("não foi possível remover...").
  const policyId = policyStore.currentPolicy?.id
  if (!policyId) {
    console.error('Policy ID não encontrado')
    return
  }

  isLoading.value = true

  try {
    await policyStore.deleteBlockedDoctor(selectedDoctor.value.id)
  } catch (err) {
    notifyError(err, 'Não foi possível remover o médico da lista de bloqueados.')
    isLoading.value = false
    return
  }

  showModal.value = false

  try {
    await policyStore.fetchBlockedDoctorsByDsPolicy(policyId)
  } catch (err) {
    notifyError(err, 'Não foi possível atualizar a lista de médicos bloqueados.')
  } finally {
    isLoading.value = false
  }
}
</script>
